import React from 'react'
import Layout from './src/components/Layout/Layout'
import './src/styles/global.css'

const shouldUpdateScroll = () => {
  if (!window.location.href.includes('#')) {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    return false
  }
  return true
}

const wrapPageElement = ({ element }) => {
  return <Layout>{element}</Layout>
}

export { wrapPageElement, shouldUpdateScroll }
